const ACTIVITY_TABS = [
    "Activity",
    "Progress Summary",
    "Assessment Summary",

 ]

const GRADES = [
    "Grade 1","Grade 2","Grade 3", "Grade 5", "Grade 7", "Grade 8", "Grade 9", "Grade 10"
 ]
 
const IR_LEVELS = [
    "L1", "L2", "L3", "L4", "L5", "L6","L7","L8","L9","L10","L11", "L12"
 ]

 export const student = {
    ACTIVITY_TABS,
    GRADES,
    IR_LEVELS
}